module.exports = __webpack_public_path__ + "img/pic_01.acbd492d.png";